import React, { useEffect, useState } from "react";
import { BreadcrumbTemplateEnum, Breadcrumbs, Page, PageHeader, PageInner, PageSection } from "@app/shared";
import OperationsService from "./operationsService";
import WeeklyComparison from "./WeeklyComparison";
import HumanaJobStatistics from "./HumanaJobStatistics";
import JobStatisticsByLineOfBusiness from "./JobStatisticsByLineOfBusiness";
import ProviderSetVersionStatus from "./ProviderSetVersionStatus";
import { HumanaProcessingReadMe } from "./readme/HumanaProcessingReadMe";
import { QESITroubleshootingReadMe } from "./readme/QESITroubleshootingReadMe";
import { UHCProcessingReadMe } from "./readme/UHCProcessingReadMe";

const operationsService = new OperationsService();

export const WeekendRunMonitoring: React.FC = () => {
  const [activeTab, setActiveTab] = useState<string>("humana");
  const [activeSubTab, setActiveSubTab] = useState<string>("readme");
  const [clientId, setClientId] = useState<number | null>(null);
  const [clients, setClients] = useState<{ clientId: number, name: string }[]>([]);
  const [users, setUsers] = useState<{ userId: number, userName: string }[]>([]);

  useEffect(() => {
    const fetchClients = async () => {
      const clientData = await operationsService.getAllClients();
      setClients(clientData);
    };
    fetchClients();
  }, []);

  // set the client id to the selected client as necessary
  useEffect(() => {
    if (clients.length > 0) {
      let activeId = clientId;
      switch (activeTab) {
        case "humana":
          activeId = clients.find((c) => c.name === "Humana")?.clientId || activeId;
          break;
        case "unitedHealthcare":
          activeId = clients.find((c) => c.name === "United HealthCare Services")?.clientId || activeId;
          break;
      }
      setClientId(activeId);
    }
  }, [clients, activeTab]);

  const handleMainTabClick = (tab: string) => {
    setActiveTab(tab);
    setActiveSubTab("readme");
  };

  const handleSubTabClick = (subTab: string) => {
    setActiveSubTab(subTab);
  };

  const renderPane = (tab: string, label: string) => (
    <li className="nav-item">
      <a
        className={`nav-link ${activeTab === tab ? "active" : ""}`}
        onClick={() => handleMainTabClick(tab)}
      >
        {label}
      </a>
    </li>
  );

  const renderSubPane = (subTab: string, label: string) => (
    <li className="nav-item">
      <a
        className={`nav-link ${activeSubTab === subTab ? "active" : ""}`}
        onClick={() => handleSubTabClick(subTab)}
      >
        {label}
      </a>
    </li>
  );

  return (
    <Page documentTitle="Weekend Run Monitoring">
      <Breadcrumbs template={BreadcrumbTemplateEnum.Operations} items={["Weekend Run Monitoring"]} />
      <PageInner>
        <PageHeader title="Weekend Run Monitoring" disableHR={true}>
        </PageHeader>
      </PageInner>

      <PageSection >
        <div className="tabs-style-2 mb-3">
          <ul className="nav nav-tabs">
            {renderPane("humana", "Humana")}
            {renderPane("unitedHealthcare", "United HealthCare Services")}
          </ul>
        </div>
        <div className="mx-3">
          {activeTab === "humana" && (
            <div>
              <div className="tabs-style-3 mb-3">
                <ul className="nav nav-tabs">
                  {renderSubPane("readme", "ReadMe")}
                  {renderSubPane("qesitroubleshooting", "QESI Troubleshooting")}
                  {renderSubPane("jobStatistics", "Job Statistics")}
                  {renderSubPane("providerSetVersionStatus", "Provider Set Version Status")}
                </ul>
              </div>
              {activeSubTab === "readme" && <HumanaProcessingReadMe />}
              {activeSubTab === "qesitroubleshooting" && <QESITroubleshootingReadMe />}
              {activeSubTab === "jobStatistics" && (
                <HumanaJobStatistics clients={clients} users={users} setUsers={setUsers} clientId={clientId} setClientId={setClientId} />
              )}
              {activeSubTab === "providerSetVersionStatus" && (
                <ProviderSetVersionStatus clients={clients} clientId={clientId} setClientId={setClientId} />
              )}
            </div>
          )}
          {activeTab === "unitedHealthcare" && (
            <div>
              <div className="tabs-style-3 mb-3">
                <ul className="nav nav-tabs">
                  {renderSubPane("readme", "ReadMe")}
                  {renderSubPane("weeklyComparison", "Weekly Comparison")}
                  {renderSubPane("jobStatisticsByLineOfBusiness", "Job Statistics by Line of Business")}
                </ul>
              </div>
              {activeSubTab === "readme" && <UHCProcessingReadMe />}
              {activeSubTab === "weeklyComparison" && <WeeklyComparison clients={clients} clientId={clientId} setClientId={setClientId} />}
              {activeSubTab === "jobStatisticsByLineOfBusiness" && <JobStatisticsByLineOfBusiness clients={clients} clientId={clientId} setClientId={setClientId} />}
            </div>
          )}
        </div>
      </PageSection>
    </Page>
  );
};